import * as React from "react"
import { SVGProps } from "react"

const TicketMiniBlue = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={25}
        height={18}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
            d="M.602 1.4v4.201a1.346 1.346 0 0 0 1.237 1.333 2.074 2.074 0 0 1 1.908 2.06 2.074 2.074 0 0 1-1.907 2.06 1.346 1.346 0 0 0-1.238 1.333v4.205A1.34 1.34 0 0 0 1.94 17.93h6.697c.414 0 .823-.097 1.193-.282a.52.52 0 0 1 .46 0c.37.185.78.281 1.194.282h17.173a1.34 1.34 0 0 0 1.34-1.34l-.003-4.203a1.347 1.347 0 0 0-1.238-1.332 2.066 2.066 0 0 1 0-4.12 1.346 1.346 0 0 0 1.238-1.333V1.402a1.34 1.34 0 0 0-1.34-1.339H11.483a2.68 2.68 0 0 0-1.194.281.518.518 0 0 1-.46 0A2.682 2.682 0 0 0 8.635.063H1.938A1.34 1.34 0 0 0 .602 1.4Zm9.458 12.282a1.078 1.078 0 0 1 1.077 1.077v1.096a1.077 1.077 0 0 1-2.153 0v-1.096a1.077 1.077 0 0 1 1.076-1.077Zm0-4.189a1.077 1.077 0 0 1 1.077 1.077v1.047a1.075 1.075 0 0 1-1.077 1.077 1.077 1.077 0 0 1-1.077-1.077V10.57a1.077 1.077 0 0 1 1.078-1.08v.003Zm0-4.189a1.077 1.077 0 0 1 1.077 1.078v1.047a1.077 1.077 0 0 1-2.153 0V6.38A1.077 1.077 0 0 1 10.06 5.3v.004Zm.005-4.234a1.077 1.077 0 0 1 1.078 1.077l-.003 1.092a1.078 1.078 0 1 1-2.154-.006l.002-1.091a1.077 1.077 0 0 1 1.078-1.077v.005Z"
            fill="#FD0058"
        />
    </svg>
)

export default TicketMiniBlue
